// Die Arten der eigenen Haeuser fuer Saetze ueber eine Menge ("so viele Verlage", M7).
// Still geladen beim Oeffnen eines Dialogs. `geklaert` sagt, ob das Laden abgeschlossen
// ist (Erfolg, Fehler oder nach FRIST_MS): bis dahin haelt ein Dialog die eine Meldung
// zurueck, die davon abhaengt, damit sie nur einmal und gleich richtig angesagt wird
// (Codex-P2 #764). Ohne Arten bleibt es bei der Gruppe.

import { useEffect, useState } from 'react';

import type { HausArt } from './haus-art.ts';
import { fetchSearchOptions } from './parties.ts';

/** Laenger wartet keine Meldung auf die Arten. */
const FRIST_MS = 1500;

export interface EigeneHausarten {
  readonly arten: readonly (HausArt | null | undefined)[] | undefined;
  readonly geklaert: boolean;
}

export function useEigeneHausarten(
  aktiv: boolean,
  apiBaseUrl: string,
  accessToken: () => Promise<string | undefined>,
): EigeneHausarten {
  const [arten, setArten] = useState<readonly (HausArt | null | undefined)[] | undefined>();
  const [geklaert, setGeklaert] = useState(false);
  useEffect(() => {
    if (!aktiv || arten !== undefined) return undefined;
    let aktuell = true;
    const frist = setTimeout(() => {
      if (aktuell) setGeklaert(true);
    }, FRIST_MS);
    void (async () => {
      try {
        const token = await accessToken();
        if (token === undefined) return;
        const antwort = await fetchSearchOptions({ baseUrl: apiBaseUrl, accessToken: token });
        if (aktuell && antwort.outcome === 'loaded') setArten(antwort.operatingContexts.map((haus) => haus.kind));
      } catch {
        // Ohne Arten bleibt der Satz bei "Gesellschaften der Gruppe".
      } finally {
        if (aktuell) setGeklaert(true);
      }
    })();
    return () => {
      aktuell = false;
      clearTimeout(frist);
    };
  }, [accessToken, aktiv, apiBaseUrl, arten]);
  return { arten, geklaert: geklaert || arten !== undefined };
}
